function TagIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0701 21.9799C10.6601 21.9799 9.24009 21.4399 8.17009 20.3699L3.64009 15.8399C2.54009 14.7399 1.96009 13.2199 2.03009 11.6699L2.27009 6.66993C2.38009 4.27993 4.27009 2.38993 6.67009 2.26993L11.6701 2.02993C13.2201 1.96993 14.7401 2.53993 15.8401 3.63993L20.3701 8.16993C22.5201 10.3199 22.5201 13.8299 20.3701 15.9799L15.9801 20.3699C14.9001 21.4399 13.4901 21.9799 12.0701 21.9799ZM4.70009 14.7699L9.23009 19.2999C9.99009 20.0599 11.0001 20.4799 12.0701 20.4799C13.1401 20.4799 14.1501 20.0599 14.9101 19.2999L19.3001 14.9099C20.0601 14.1499 20.4801 13.1399 20.4801 12.0699C20.4801 10.9999 20.0601 9.98993 19.3001 9.22993L14.7701 4.69993C13.9701 3.89993 12.8601 3.46993 11.7401 3.52993L6.74009 3.76993C5.11009 3.83993 3.84009 5.10993 3.76009 6.72993L3.52009 11.7299C3.47009 12.8599 3.90009 13.9699 4.70009 14.7699Z"
        fill="black"
        className="fill"
      />
      <path
        d="M9.5 12.75C7.71 12.75 6.25 11.29 6.25 9.5C6.25 7.71 7.71 6.25 9.5 6.25C11.29 6.25 12.75 7.71 12.75 9.5C12.75 11.29 11.29 12.75 9.5 12.75ZM9.5 7.75C8.54 7.75 7.75 8.54 7.75 9.5C7.75 10.46 8.54 11.25 9.5 11.25C10.46 11.25 11.25 10.46 11.25 9.5C11.25 8.54 10.46 7.75 9.5 7.75Z"
        stroke="black"
        className="stroke"
      />
    </svg>
  );
}

export default TagIcon;
